import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@tech-utils/app-config.service';
import {
  PortfolioService,
  CompletedataService as sdkService,
} from '@techrules/portallib';
import { ModalservicedisabledComponent } from './modalservicedisabled/modalservicedisabled.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '@tech-services/common.service';
import { Subject, takeUntil } from 'rxjs';
import { OnboardingRedirector } from '@tech-utils/onboardingredirector';

@Component({
  selector: 'tech-investmentservice',
  templateUrl: './investmentservice.component.html',
  styleUrls: ['./investmentservice.component.scss'],
})
export class InvestmentserviceComponent implements OnInit {
  public loaded: Boolean = true; //false
  public nodata: Boolean = false; //true
  public services: any[] = [];
  public customTheme: string = localStorage.getItem('ThemeImg');
  private unsubscribe$ = new Subject();
  Name: string = '';
  Surname: string = '';
  isback: boolean = true;

  constructor(
    private router: Router,
    private portfolioService: PortfolioService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private onboardingRedirector: OnboardingRedirector
  ) {}

  ngOnInit(): void {
    /*
    this.services = [{ServiceModelCode: "0", ServiceModelName:"modelo 1", ServiceModelDescription: "desc modelo 1", Image:"inversion1",IsAccessible: true, SectionsToComplete: ""},
    {ServiceModelCode: "1", ServiceModelName:"modelo 2", ServiceModelDescription: "desc modelo 2", Image:"inversion2",IsAccessible: true, SectionsToComplete: ""},
    {ServiceModelCode: "2", ServiceModelName:"modelo 3", ServiceModelDescription: "desc modelo 3", Image:"inversion3",IsAccessible: false, SectionsToComplete: "Perfil fiscal, Perfil financiero"}
  ];*/

    this.portfolioService.getServiceModel().subscribe((data) => {
      this.services = data;
      console.log(data);
      if (this.services.length == 0) this.nodata = true;
      else this.nodata = false;
      this.loaded = true;
    },
    (err)=>{
      this.nodata = true
    }
  );
  }

  goBack() {
    this.router.navigate(['/portfolios']);
  }

  getimagen(imagen) {
    let icon = '';
    switch (imagen) {
      case 'inversion1':
        icon =
          './assets/img/' +
          this.customTheme +
          '/investmentservice/inversion1.png';
        break;
      case 'inversion2':
        icon =
          './assets/img/' +
          this.customTheme +
          '/investmentservice/inversion2.png';
        break;
      default:
        icon =
          './assets/img/' + this.customTheme + '/investmentservice/default1.png';
        break;
    }
    return icon;
  }

  goModal(item) {
    const dialogRef = this.dialog.open(ModalservicedisabledComponent, {
      width: '90%',
      height: 'auto',
      maxWidth: '440px',
      minWidth: '420px',
      panelClass: 'dialogfluid-intocenter3',
      data: {
        item: item,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  clickgoto(code) {
    this.portfolioService.clientPortfolio(code).subscribe((data) => {
      this.commonService
        .getClientData()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          if (res && res !== null && res !== undefined) {
            this.Name = res.Name;
            this.Surname = res.Surname;
            this.onboardingRedirector
              .redirect({
                onboardingNextAction: data.OnboardingNextAction,
                portfolioCode: data.PortfolioCode,
                clientName: this.Name,
                clientSurname: this.Surname,
                servicemodelcode: code,
              })
              .subscribe((url) => {
                //reditect to url
                this.router.navigateByUrl(url);
              });
          }
        });
    });
  }
}
